import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import {
  CardVerification,
  CardVerificationRequest,
  CardVerificationResponse,
} from './types'

const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'client') {
        return [`${item[0]}.email`, item[1]?.toLowerCase()]
      } else if (item[0] === 'updatedAt' || item[0] === 'expiry') {
        const value =
          Array.isArray(item[1]) &&
          item[1].map((date) =>
            date ? changedDateFormat(date?.$d) : `${date}`,
          )
        return [item[0], value]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const cardVerificationsListMounted =
  createEvent<CardVerificationRequest>()

export const getCardVerifications = fx<
  CardVerificationRequest,
  CardVerificationResponse
>({
  method: 'GET',
  url: `/client_purse`,
})

export const $cardVerifications = restore<CardVerification[]>(
  getCardVerifications.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfCardVerifications = restore(
  getCardVerifications.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: cardVerificationsListMounted,
  fn: ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
    filters,
  }) => {
    if (orderDirection == 'descend') {
      orderDirection = '-'
    } else if (orderDirection == 'ascend') {
      orderDirection = ''
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'status'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      newObj = {
        ...newObj,
        isCard: 'true',
      }
      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getCardVerifications,
})
